import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import CheckScreen from '../../organisms/Check';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1
  }
}));

const Check = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <CheckScreen/>
    </div>
  );
}

export default Check;